export function x(namespace: string, ...args: any[]) {
  if (window && window.console) {
    window.console.log(namespace, ...args)
  }
}

export function json(namespace: string, arg: any) {
  if (window && window.console) {
    window.console.log(namespace, 'json')
    window.console.log(JSON.stringify(arg, null, 2))
  }
}
